// extracted by mini-css-extract-plugin
module.exports = {"container":"StakeholderResponsesWidget_container__3uY0g","title":"StakeholderResponsesWidget_title__38Oul","dashedGridLines":"StakeholderResponsesWidget_dashedGridLines__2shwX"};